import React from 'react'
import Navbar from '../components/Navbar'
import EsgComponent from '../components/Esg'
import Footer from '../components/Footer'
import Scroll from '../components/Utils'

const Esg = () => {
    return (
        <>
            <Scroll />
            <Navbar />
            <EsgComponent />
            <Footer />
        </>
    )
}

export default Esg